const Footer = () => {
    return (
        <section className="w-full py-4 px-10 lg:py-10 bg-sbPallet-cardBg flex flex-col items-center gap-8">
            <div className="text-center border-t border-white/10 w-full pt-6">
                <p className="font-black uppercase">Raúl Pérez</p>
                <p className="text-sm text-white/70">Health &amp; Performance Coach</p>
            </div>
        </section>
    )
}

export default Footer